import React, { useState, useEffect } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { useHistory } from "react-router-dom";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import IconButton from "@material-ui/core/IconButton";

import {
  subirImagenesBatch,
  addRegistro,
  getEmployeeNumber,
  getUserByEmail,
  loadAccountList,
  getAdminUsers,
} from "../utils/Actions";
import { isEmpty, size } from "lodash";
import Avatar from "@material-ui/core/Avatar";
import { Loading } from "../atoms";
import {
  generatePasswordRand,
  sendEmail,
  validaremail,
  sendEmailWithCopy,
} from "../utils/Utils";

const inintialState = {
  name: "",
  lastname: "",
  userweb: "",
  email: "",
  accountAsigned: "",
  accountAsignedName: "",
  isSupervisor: false,
  rol: "",
  photo: "",
  createdby: "",
  status: true,
};

const roles = [
  { code: 1, title: "Seguridad" },
  { code: 2, title: "Jefe de Operaciones" },
  { code: 3, title: "Administrador" },
  { code: 4, title: "Cliente" },
];

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  icon: {
    alignSelf: "center",
  },
  avatar: {
    width: 100,
    height: 100,
    marginBottom: 20,
  },
}));

export default function AddUser() {
  const [state, setstate] = useState(inintialState);
  const [visible, setVisible] = useState(false);
  const [accountlist, setaccountlist] = useState([]);
  const [emails, setemails] = useState([]);

  let history = useHistory();
  const account = localStorage.getItem("Account");
  const accountJSON = JSON.parse(account);
  const { rol, accountAsigned, accountAsignedName } = accountJSON[0];
  console.log(accountJSON);

  useEffect(() => {
    (async () => {
      console.log("LOAD ACCOUNT LIST");
      let resultado = [];
      setaccountlist((await loadAccountList()).data);
      const emailsdata = await getAdminUsers();
      emailsdata.data.forEach((item) => {
        resultado.push(item.email);
      });

      console.log(resultado.join(","));
      setemails(resultado);
    })();
  }, []);

  const classes = useStyles();

  const defaultProps = {
    options: roles,
    getOptionLabel: (option) => option.title,
  };

  const defaultProps2 = {
    options: accountlist,
    getOptionLabel: (option) => option.name,
  };

  const fileSelectedHandler = async (event) => {
    setVisible(true);
    const resultado = await subirImagenesBatch(event.target.files, "avatarWeb");
    setstate({ ...state, photo: resultado[0] });
    setVisible(false);
  };

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  const _saveuser = async () => {
    //1. Subir imagen
    const { name, lastname, accountAsigned, rol, isSupervisor, email, photo } =
      state;

    let url = "";
    let numeroempleado = "";

    if (isEmpty(name) || isEmpty(lastname)) {
      alert("Debe ingresar el nombre y el apellido del usuario");
    } else if (!accountAsigned && Number(rol) !== 3) {
      alert("Debe seleccionar una cuenta de cliente");
    } else if (!rol) {
      alert("Debe seleccionar un rol");
    } else if (isEmpty(photo)) {
      alert("Debe seleccionar una fotografía");
    } else if (!isEmpty(email) && !validaremail(email)) {
      alert("Debe ingresar un correo válido");
    } else if (Number(rol) === 4 && isEmpty(accountAsigned)) {
      alert("Debe asociar el cliente a una cuenta");
    } else {
      setVisible(true);

      const secuencial = await getEmployeeNumber();
      console.log("OBTENER SECUENCIAL");
      console.log(secuencial);
      let passwordweb = generatePasswordRand(6, "rand");
      if (secuencial.statusresponse) {
        numeroempleado = secuencial.data;
      } else {
        numeroempleado = 4000;
      }

      //2. Generar claves

      const usuario = {
        ...state,
        photo: photo,
        createdAt: new Date(),
        createby: "user",
        employeenumber: numeroempleado,
        publickey: "",
        privatekey: "",
        secretkey: "",
        adminpassword:
          rol === 3
            ? Number(Math.random() * (9999 - 1000) + 1000).toFixed(0)
            : 0,
        status: true,
        isSupervisor,
        passwordweb,
        userweb: `${name}.${lastname}`.toLowerCase(),
      };
      let flujo = true;
      if (!isEmpty(email)) {
        const existsuser = await getUserByEmail(email);
        flujo = existsuser.statusresponse;
      }

      if (!flujo === true) {
        const registro = await addRegistro("Usuarios", usuario);

        const ccemail = encodeURIComponent(emails.join(","));

        if (registro.statusresponse === true) {
          let userfinal = `${name}.${lastname}`;

          await sendEmailWithCopy(
            `<p>Se ha creado su usuario: ${encodeURIComponent(
              userfinal.toLowerCase()
            )} <br/> Su contraseña es: ${encodeURIComponent(
              passwordweb
            )} </p> Para ingresar a la plataforma de Sayeret Security, favor ingrese a la siguiente dirección: <a href="https://www.sayeretsecurity.net/" >Acceder a la Web</a>`,
            "Usuario creado en Sayeret Security",
            state.email,
            ccemail
          );
          //console.log(state.photo);
          setVisible(false);
          setstate({
            ...state,
            name: "",
            lastname: "",
            accountAsigned: 0,
            rol: 0,
            schedule: "",
            photo: "",
            fingerprint: "",
            isSupervisor: false,
            email: "",
          });
          alert("Se ha creado el usuario exitosamente");
          history.push("/users");
        } else {
          setVisible(false);
          alert("Ha ocurrido un error - CODIGO" + registro.error);
        }
      } else {
        setVisible(false);

        alert("Ya existe un usuario creado con el correo " + email);
      }
    }
  };

  return (
    <FormControl
      style={{
        backgroundColor: "#fff",
        borderRadius: 5,
        padding: 20,
        paddingBottom: 30,
      }}
    >
      <Typography gutterBottom variant="h5">
        <IconButton>
          <ChevronLeftIcon onClick={() => history.goBack()} />
        </IconButton>
        Crear Nuevo Usuario
      </Typography>

      <Grid
        item
        xs={12}
        direction="column"
        justify="center"
        alignItems="center"
        container
        spacing={0}
        style={{ marginBottom: 20 }}
      >
        {isEmpty(state.photo) ? (
          <AccountCircleIcon fontSize="large" style={{ fontSize: 50 }} />
        ) : (
          <Avatar alt="Photo" src={state.photo} className={classes.avatar} />
        )}
        <input
          type="file"
          onChange={fileSelectedHandler}
          accept="image/png, image/jpeg"
        />
      </Grid>
      <Grid container spacing={5}>
        <Grid item xs={6} sm={6}>
          <TextField
            id="outlined-basic"
            label="Nombre"
            variant="outlined"
            fullWidth
            name="name"
            onChange={onChange}
            value={state.name}
            onSubmit={() => {
              console.log("salio");
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <TextField
            id="outlined-basic"
            label="Apellido"
            variant="outlined"
            fullWidth
            name="lastname"
            onChange={onChange}
            value={state.lastname}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="outlined-basic"
            label="Usuario"
            variant="outlined"
            fullWidth
            name="userweb"
            onChange={onChange}
            disabled
            value={`${state.name.trim().toLowerCase()}.${state.lastname
              .trim()
              .toLowerCase()}`}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="outlined-basic"
            label="Correo"
            variant="outlined"
            fullWidth
            type="email"
            name="email"
            onChange={onChange}
            value={state.email}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                onChange={(e) => {
                  setstate({ ...state, isSupervisor: e.target.checked });
                }}
                value={state.isSupervisor}
                disabled={rol !== 4 ? false : true}
              />
            }
            label="Supervisor de Cuenta"
            labelPlacement="start"
            value={state.isSupervisor}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            {...defaultProps}
            id="open-on-focus"
            openOnFocus
            renderInput={(params) => (
              <TextField
                {...params}
                label="Seleccione el Rol"
                margin="normal"
              />
            )}
            onChange={(event, newValue) => {
              setstate({ ...state, rol: newValue.code });
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            {...defaultProps2}
            id="open-on-focus"
            openOnFocus
            renderInput={(params) => (
              <TextField
                {...params}
                label="Seleccione Cuenta"
                margin="normal"
              />
            )}
            onChange={(event, newValue) => {
              console.log(newValue);

              setstate({
                ...state,
                accountAsigned: newValue.id,
                accountAsignedName: newValue.name,
              });
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          direction="row"
          justify="center"
          alignItems="center"
          container
        >
          <Button
            size="large"
            variant="contained"
            color="secondary"
            startIcon={<SaveIcon />}
            onClick={_saveuser}
          >
            GUARDAR
          </Button>
        </Grid>
      </Grid>
      <Loading visible={visible} setVisible={setVisible} />
    </FormControl>
  );
}
